import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { BrokerInformationSection, LoanInformationSection, CorrespondentOnlySection } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface CorrHeaderFormData {
  amEmail: string;
  loanNumber: string;
  lockExpirationDate: string;
  companyName: string;
  companyLicense: string;
  phone: string;
  fax: string;
  processorName: string;
  processorEmail: string;
  loanOfficerName: string;
  loanOfficerEmail: string;
}

@Component({
  selector: 'corr-header',
  templateUrl: './corr-header.component.html',
  styleUrls: ['./corr-header.component.scss'],
  standalone: false
})
export class CorrHeaderComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('corrHeaderForm') corrHeaderForm: NgForm;

  @Input() brokerInformation: BrokerInformationSection | undefined;
  @Input() loanInformation: LoanInformationSection | undefined;
  @Input() correspondentOnly: CorrespondentOnlySection | undefined;

  formData: CorrHeaderFormData = {
    amEmail: '',
    loanNumber: '',
    lockExpirationDate: '',
    companyName: '',
    companyLicense: '',
    phone: '',
    fax: '',
    processorName: '',
    processorEmail: '',
    loanOfficerName: '',
    loanOfficerEmail: ''
  };

  isLoading: boolean = false;

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['brokerInformation'] || changes['loanInformation'] || changes['correspondentOnly']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.corrHeaderForm) {
      this.corrHeaderForm.form.markAllAsTouched();
      return this.corrHeaderForm.form.valid;
    }
    return true;
  }

  getFormData(): CorrHeaderFormData {
    return { ...this.formData };
  }

  private populateFormFromApiData(): void {
    if (this.brokerInformation) {
      this.formData.companyName = this.brokerInformation.tpoCompanyName || '';
      this.formData.companyLicense = this.brokerInformation.tpoCompanyNmls || '';
      this.formData.phone = this.brokerInformation.tpoCompanyPhone || '';
      this.formData.fax = this.brokerInformation.tpoCompanyFax || '';
      this.formData.processorName = this.brokerInformation.processorName || '';
      this.formData.processorEmail = this.brokerInformation.processorEmail || '';
      this.formData.loanOfficerName = this.brokerInformation.loanOfficerName || '';
      this.formData.loanOfficerEmail = this.brokerInformation.loanOfficerEmail || '';
    }

    if (this.loanInformation) {
      this.formData.loanNumber = this.loanInformation.loanNumber || '';
    }

    if (this.correspondentOnly) {
      this.formData.amEmail = this.correspondentOnly.accountManagerEmail || '';
      this.formData.lockExpirationDate = this.correspondentOnly.lockExpirationDate || '';
    }
  }
}
